import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import c from 'classnames';
import { ActionBarDialogContext } from '../../../ActionBarContext';
import PopoverWithTooltip from '../../../../Popover/Preset/PopoverWithTooltip';
import s from './ActionBarItemWrapper.scss';
/**
 * Wraps any item we're going to place on the ActionBar. It provides a popover tooltip.
 *
 * e.g.
 * ```
 * <ActionBarItemWrapper tooltip="Hello World">
 *   <ActionBarButton href="...">
 *     <Icon />
 *   </ActionBarButton>
 * </ActionBarItemWrapper>
 * ```
 */
var ActionBarItemWrapper = function (_a) {
    var allowMobilePopover = _a.allowMobilePopover, className = _a.className, popoverWrapperClassName = _a.popoverWrapperClassName, forceVisibleTooltip = _a.forceVisibleTooltip, rest = __rest(_a, ["allowMobilePopover", "className", "popoverWrapperClassName", "forceVisibleTooltip"]);
    var isAnyDialogOpen = useContext(ActionBarDialogContext);
    return (React.createElement(PopoverWithTooltip, __assign({ allowMobile: allowMobilePopover, isDisabled: isAnyDialogOpen, contentClassName: s['popover'], wrapperClassName: c(s['root-wrapper'], className), referenceClassName: c(s['popover-wrapper'], popoverWrapperClassName), forceVisibleTooltip: forceVisibleTooltip }, rest)));
};
ActionBarItemWrapper.displayName = 'ActionBarItemWrapper';
export default ActionBarItemWrapper;
//# sourceMappingURL=ActionBarItemWrapper.js.map